import React, { useEffect, useCallback, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Divider from '@material-ui/core/Divider'
import Alert from '@material-ui/lab/Alert'
import AlertTitle from '@material-ui/lab/AlertTitle'
import objectPath from 'object-path'

import projectSelectors from 'store/selectors/project'
import bookSelectors from 'store/selectors/booking'
import routerSelectors from 'store/selectors/router'
import routerActions from 'store/modules/router'
import bookActions from 'store/modules/booking'
import SummaryWrapper from './SummaryWrapper'
import Template from 'shared/src/template'
import BusinessDetails from 'components/book/BusinessDetails'

import constants from 'shared/src/constants'

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(2),
  },
  payButton: {
    margin: theme.spacing(2),
  },
  businessDetails: {
    width: '400px',
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  alert: {
    marginBottom: theme.spacing(2),
  }
}))

const BookingFormPayment = ({
  
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  
  const slot = useSelector(bookSelectors.slot)
  const config = useSelector(bookSelectors.slotFormConfig)
  const options = useSelector(bookSelectors.options)
  const details = useSelector(bookSelectors.details)
  const reservation = useSelector(bookSelectors.reservation)
  const slotConfig = useSelector(bookSelectors.slotFormConfig)
  const stripeConnect = useSelector(projectSelectors.currentProjectStripeConnect)

  const {
    project,
    bookingform,
  } = useSelector(routerSelectors.params)

  const template = useMemo(() => {
    return Template({
      slot,
      config,
      options,
    })
  }, [
    slot,
    config,
    options,
  ])

  const data = useMemo(() => {
    return {
      depositTitle: template.context.getPayNowTitle(),
      title: template(objectPath.get(config, 'payment.payment_title', 'Deposit for booking')),
      notes: objectPath.get(config, 'payment.payment_notes', []).map(note => template(note)),
    }
  }, [
    template,
    config,
  ])

  const onPay = useCallback(() => {
    dispatch(bookActions.pay({
      project,
      bookingform,
    }))
  }, [])

  const onBack = useCallback(() => {
    dispatch(routerActions.navigateTo('book.form.details', {
      project,
      bookingform,
    }))
  }, [
    project,
    bookingform,
  ])

  useEffect(() => {
    if(reservation && reservation.status == constants.BOOKING_STATUS_CONFIRMED) {
      dispatch(routerActions.navigateTo('book.form.confirm', {
        project,
        bookingform,
      }))
      return
    }
    if(details) return
    dispatch(routerActions.navigateTo('book.form.details', {
      project,
      bookingform,
    }))
  }, [
    project,
    bookingform,
    details,
    reservation,
  ])

  return (
    <SummaryWrapper
      withStoreOptions
      withForward={ false }
      withAlert={ stripeConnect ? false : true }
      onBack={ onBack }
    >
      <div className={ classes.root }>
        <Typography gutterBottom variant="h6">{ data.title }</Typography>
        {
          stripeConnect ? (
            <Button
              variant="contained"
              color="secondary"
              className={ classes.payButton }
              onClick={ onPay }
            >
              Pay { data.depositTitle } with Stripe
            </Button>
          ) : (
            <Alert
              className={ classes.alert }
              severity="error"
            >
              <AlertTitle>Payment Not Configured</AlertTitle>
              This project has not connected their Stripe account and so we can't take any payments for you until they have connected their Stripe account.
            </Alert>
          )
        }
        
        {
          data.notes.map((note, i) => (
            <Typography key={ i } gutterBottom variant="body1">{ note }</Typography>
          ))
        }
        <Divider className={ classes.divider } />
        <Typography gutterBottom variant="body1">In the meantime, if you have any questions, you can get in touch:</Typography>
        <Paper className={ classes.businessDetails }>
          <BusinessDetails
            slotConfig={ slotConfig }
          />
        </Paper>
        
      </div>
    </SummaryWrapper>
  )
}

export default BookingFormPayment